import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

import { Footer, ProcModal } from '@sonyged/ext-proc';

export default class HintModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: true,
    };
  }

  render() {
    return (
      <ProcModal isOpened={this.state.isOpened} rootNodeId={`proc-${this.props.kind}-fields-root-page`}>
        <div key="modal" className={'proc-modal proc-modal--hint'}>
          <div className="proc-modal-container">
            <div className={'proc-modal-header'}>ヒント</div>
            <div className={'proc-modal-contents gray100-color proc-font-medium'}>
              <div className={`proc-field-hint-container proc-border-radius proc-medium-font ${this.props.kind}`}>
                {this.props.message}
              </div>
            </div>
          </div>
          <Footer.normal shadow={false}>
            <Link
              to={{ pathname: `/${this.props.kind}/fields`, search: '?skip_intro=true' }}
              className={'proc-button proc-button--attention'}
            >
              しゅうりょう
            </Link>
          </Footer.normal>
        </div>
      </ProcModal>
    );
  }
}

HintModal.propTypes = {
  kind: PropTypes.string,
  message: PropTypes.object,
};

HintModal.defaultProps = {};
